import { wasmApi } from '@shared/Service'
import { toBase64, WasmContractQueryResponse } from '@injectivelabs/sdk-ts'
import { MitoConfigTransformer } from '@/app/client/transformers/config'
import { VaultConfig, VaultContractType } from '@/types'

export const resetVaultConfig = () => {
  const mitoStore = useMitoStore()

  mitoStore.vaultConfig = {} as VaultConfig
}

export const fetchVaultConfig = async ({
  type,
  vaultAddress
}: {
  type: VaultContractType
  vaultAddress: string
}) => {
  const mitoStore = useMitoStore()

  const queryConfigPayload =
    type === VaultContractType.OffChain
      ? toBase64({ config: {} })
      : toBase64({ base: { config: {} } })

  const vaultConfigResponse = (await wasmApi.fetchSmartContractState(
    vaultAddress as string,
    queryConfigPayload
  )) as WasmContractQueryResponse

  if (type === VaultContractType.OffChain) {
    mitoStore.vaultConfig =
      MitoConfigTransformer.configResponseToOffChainVaultConfig(
        vaultConfigResponse
      )
  }

  if (type === VaultContractType.ASMMPerp) {
    mitoStore.vaultConfig =
      MitoConfigTransformer.configResponseToDerivativeVaultConfig(
        vaultConfigResponse
      )
  }

  if (type === VaultContractType.ASMMSpot) {
    mitoStore.vaultConfig =
      MitoConfigTransformer.configResponseToSpotVaultContractConfig(
        vaultConfigResponse
      )
  }

  if (type === VaultContractType.CPMM) {
    mitoStore.vaultConfig =
      MitoConfigTransformer.configResponseToCPMMVaultConfig(vaultConfigResponse)
  }
}

export * from './update'
export * from './instantiate'
